import ky, { type Options, isHTTPError } from 'ky';
import Cookies from 'universal-cookie';

import { COOKIE_USER_TOKEN } from '@/constants/cookie.constants';

import { errorCodeMap } from './errorCodeMap';

const cookies = new Cookies();

// This client is for data fetching from client

const opts: Options = {
  prefix: `${process.env.NEXT_PUBLIC_AUTH_BASE_API_URL}/`,
  timeout: 15000,
  hooks: {
    beforeRequest: [
      async ({ request }) => {
        const token = cookies.get(COOKIE_USER_TOKEN);
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
      },
    ],
    beforeError: [
      async ({ error }) => {
        if (!isHTTPError(error)) {
          return error;
        }
        // Log errors in development
        if (process.env.DEBUG) {
          console.warn(`Error ${error.response.status} for ${error.request.method} "${error.request.url}"`);
          if (error.data !== undefined) {
            console.warn('Received: ', error.data);
          }
        }
        return error;
      },
      async ({ error }) => {
        if (!isHTTPError(error)) {
          return error;
        }
        const body = error.data;
        // Try to use the response body to return the error message from the server
        if (body && typeof body === 'object') {
          console.warn('Error received from the server', body);
          if ('message' in body && typeof body.message === 'string' && body.message.length) {
            error.message = body.message;
          }
          if ('code' in body) {
            // Handle error code mapping
            const errorCode = `${body.code}`;
            if (errorCodeMap.has(errorCode)) {
              error.message = errorCodeMap.get(errorCode)!;
            }
          }
        }

        return error;
      },
    ],
  },
};

/**
 * Note: only to be used in server components
 */
export const carmaCsrAuthClient = ky.create({
  ...opts,
  headers: {
    'Content-Type': 'application/json',
  },
});
